<template>
    <div class="statements">
        <div class="statements__title">
            <h2>Declaração</h2>
        </div>
        <FormKit
            type="form"
            :value="{
                declaracao_cnh: '',
                declaracao_renavam: '',
                termVersionId: ''
            }"
            submit- label="Continuar" @submit="confirmData"
        >
            <FormKit
                type="checkbox"
                label="Declaro que minha carteira nacional de habilitação (CNH) está regulamentada de acordo com as leis de trânsito."
                name="declaracao_cnh"
                :value="false"
                v-model="formData.declaracao_cnh"
            />
            <FormKit
                type="checkbox"
                label="Declaro que o documento do meu veículo (RENAVAM) está de acordo com as leis de trânsito."
                name="declaracao_renavam"
                :value="false"
                v-model="formData.declaracao_renavam"
            />
            <FormKit
                type="checkbox"
                name="terms"
                :value="false"
                v-model="formData.term"
            >
            <template #label>
                <label>
                    Declaro que li e aceito os
                    <router-link to="/final/termos-de-uso" class="link-appearance">Termos e condições de uso</router-link>
                </label>
            </template>
            </FormKit>

            <template #submit>
                <FooterButton :isDisabled="!formData.declaracao_cnh || !formData.declaracao_renavam || !formData.term"/>
            </template>
        </FormKit>
    </div>
</template>
<script>
  import FooterButton from '../../components/FooterButton.vue';
  import { useStore } from '../../../stores/cadastro.js';
  import { useRouter } from 'vue-router'
  import { ref } from 'vue';
  import axios from 'axios';
  import Swal from 'sweetalert2';

  export default{
    components: {
        FooterButton
    },
    data() {
        return {
            declaracao_cnh: '',
            declaracao_renavam: ''
        }
    },
    setup() {
        const store = useStore();
        const router = useRouter();

        const formData = ref({
            declaracao_cnh: false,
            declaracao_renavam: false,
            term: false
        });

        const confirmData = async (formData) => {
            await store.updateStatements(formData);
            const data = store.getStatements;
            data.registration_steps = { completed: true };
            const driverId = store.getDriverId;

            try {
                const responseTerms = await axios.get(`/_api_proxy/drivers/${driverId}/terms-acceptance`)

                const termVersionId = responseTerms.data.pendingAcceptances.length > 0
                ? responseTerms.data.pendingAcceptances[0].termVersionId
                : responseTerms.data.acceptedTerms?.slice(-1)[0]?.termVersionId;

                if (termVersionId != null) {
                  const responseAcceptance = await axios.post(`/_api_proxy/drivers/${driverId}/terms-acceptance`, {
                    termVersionId: termVersionId,
                    accepted: true,
                    location: null
                  });
                }

                const responseUpdateDriver = await axios.post(`/cadastro-motorista/update/${driverId}`, {
                    data: data
                });

                if (responseUpdateDriver.status !== 200) {
                    throw new Error(responseUpdateDriver.status);
                }

                if (responseUpdateDriver.status === 200 ) {
                    store.registrationCompleted();

                    const result = await Swal.fire({
                        title: 'Declarações salvas!',
                        icon: 'success',
                        confirmButtonText: 'Ok'
                    });

                    if (result.isConfirmed) {
                        router.push({ name: 'ApprovalFeedbackScreen' });
                    }
                }
            } catch (error) {
                Swal.fire({
                title: 'Ops...',
                text: 'Erro inesperado, por favor tente novamente mais tarde.',
                icon: 'error',
                confirmButtonText: 'Ok'
                });
            }
        }
        return {
            confirmData,
            formData
        }
    }
  }

</script>
<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .statements {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
    .statements__title h2 {
        font-size: 24px;
        font-weight: 500;
        color: #22232C;
        padding-left: 16px;
    }
    .input-checkbox .formkit-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;
    }

    .checkboxCustom {
        width: 24px;
        height: 24px;
        border: 1px solid #C5D1E2;
    }
    .label-checkbox {
        font-size: 16px;
        font-weight: 500;
        color: #435254;
        line-height: 24px;
    }
    label {
        font-size: 16px;
        font-weight: 500;
        color: #435254;
        line-height: 24px;
    }
    .link-appearance {
        color: #3A3AC5;
    }
</style>
